import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import * as actions from '../../../../../redux/projects/actions.projects';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import TextFieldWrapper from '../../../../components/TextFieldWrapper/TextFieldWrapper';
import ToasterService from '../../../../../services/ToasterService';
import FilterSwitcher from '../../../../components/FilterSwitcher/FilterSwitcher';
import { validateCohortName } from '../../../../../services/validations/validateCohortName';
import SearchLocation from '../SearchLocation/SearchLocation';
import ProgressLoader from '../../../../components/ProgressLoader/ProgressLoader';
import cohortHelper from '../../../../../services/CohortHelper';

const DEFAULT_MAX_NUMBER_OF_DEVICES = 1;
const DEFAULT_SELECT_PERCENTAGE = 50;
class CohortForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        const { cohort } = props;
        this.state = {
            saving: false,
            name: cohort.name,
            maxNumberOfDevices: (cohort.maxNumberOfDevices === -1 ? false : cohort.maxNumberOfDevices)
                || cohort.currentNumberOfDevices || DEFAULT_MAX_NUMBER_OF_DEVICES,
            enabledSelectPercentage: cohort.enabledSelectPercentage,
            selectPercentage: cohort.selectPercentage,
            currentNumberOfDevices: cohort.currentNumberOfDevices,
            limitNumberOfDevices: cohort.limitNumberOfDevices,
            limitedLocations: cohort.rules.limitedLocations,
            locations: cohort.rules.locations
        };

        this.maxFieldLength = 30;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    validate = () => {
        let nameFieldError = null;
        let nameFieldInfo = null;
        let maxNumberOfDevicesFieldError = null;
        let selectPercentageFieldError = null;
        const { cohorts, cohort } = this.props;
        const { name, maxNumberOfDevices, limitNumberOfDevices, enabledSelectPercentage, selectPercentage } = this.state;
        const maxUsersUpperLimit = 2147483647;

        nameFieldError = validateCohortName(name, cohorts.filter(curCohort => curCohort.id !== cohort.id));

        const maxUsersNumber = this.maxUsersValidate();

        if (maxUsersNumber) {
            maxNumberOfDevicesFieldError = maxUsersNumber;
        } else if (limitNumberOfDevices) {
            if (maxNumberOfDevices < 1) {
                maxNumberOfDevicesFieldError = 'Max number of users must be greater than 0';
            }
            if (maxNumberOfDevices > maxUsersUpperLimit) {
                maxNumberOfDevicesFieldError = `Max number of users must be less than ${maxUsersUpperLimit}`;
            }
        }

        if (enabledSelectPercentage) {
            if (selectPercentage < 0) {
                selectPercentageFieldError = 'Select percentage must be equal or greater than 0';
            } else if (selectPercentage > 100) {
                selectPercentageFieldError = 'Select percentage must be equal or lower than 100';
            }
        }

        this.setState({
            nameFieldError,
            nameFieldInfo,
            maxNumberOfDevicesFieldError,
            selectPercentageFieldError
        });

        return nameFieldError === null &&
            nameFieldInfo === null &&
            maxNumberOfDevicesFieldError === null &&
            selectPercentageFieldError === null;
    }

    validateFieldLength = (fieldType) => {
        const field = this.state[fieldType];
        let fieldInfo = null,
            type;
        if (field.length > this.maxFieldLength) {
            if (!this.state[fieldType + 'FieldLength']) {
                this.setState({ [fieldType + 'FieldLength']: field.length });
            }
            if (fieldType === 'name') {
                type = 'name';
            }
            return `Max ${type} length: ${this.maxFieldLength} characters`;
        }

        this.setState({ [fieldType + 'FieldLength']: null });

        return fieldInfo;
    }

    onLengthValidate = () => {
        this.validateFieldLength('name');
    }

    maxUsersValidate = () => {
        if (this.state.maxNumberOfDevices < this.props.cohort.currentNumberOfDevices) {
            return `Limit can't be lower then current amount of devices.`;
        }
    };

    onTextInputChange = (e) => {
        const field = e.target.name;
        const fieldValue = e.target.value;
        const newState = { ...this.state };

        if (field === 'name') {
            newState[field] = fieldValue;
        } else {
            const re = /^[0-9\.\b]+$/;
            if (fieldValue === '' || re.test(fieldValue)) {
                newState[field] = fieldValue;
            }
        }
        this.setState(newState, () => {
            this.validate();
        });
    }

    onTextInputBlur = (validationType) => {
        const { cohort } = this.props;
        const editedCohort = this.getUpdatedCohort();
        setTimeout(() => {
            if (cohort.name !== editedCohort.name ||
                (cohort.limitNumberOfDevices &&
                    cohort.maxNumberOfDevices !== editedCohort.maxNumberOfDevices) ||
                cohort.selectPercentage !== editedCohort.selectPercentage
            ) {
                this.updateCohort();
            }
        });
    }

    getUpdatedCohort() {
        const { cohort } = this.props;
        const {
            name,
            maxNumberOfDevices,
            enabledSelectPercentage,
            selectPercentage,
            limitNumberOfDevices,
            limitedLocations,
            locations
        } = this.state;

        return {
            ...cohort,
            name,
            maxNumberOfDevices,
            enabledSelectPercentage,
            selectPercentage,
            limitNumberOfDevices,
            rules: {
                locations,
                limitedLocations
            }
        };
    }

    updateCohort = () => {
        const { updateCohort, projectId, environment } = this.props;
        if (!this.validate()) return;
        this.setState({ saving: true });

        updateCohort({
            cohort: this.getUpdatedCohort(),
            projectId,
            environment
        }).then(this.resetSavingState, this.resetSavingState,);
    }

    resetSavingState = () => {
        if (this._isMounted) {
            this.setState({ saving: false });
        }
    }

    addLocation = (location) => {
        const { locations } = this.state;
        this.setState({ locations: [...locations, location] }, () => {
            this.updateCohort();
        });
    }

    deleteLocation = (ind) => {
        const { locations } = this.state;
        locations.splice(ind, 1);
        this.setState({ locations }, () => {
            this.updateCohort();
        });
    }

    changeSpecifyLocationFlag = () => {
        this.setState({ limitedLocations: !this.state.limitedLocations }, () => {
            this.updateCohort();
        });
    }

    changeNumberOfDevicesFlag = () => {
        const { limitNumberOfDevices, maxNumberOfDevices } = this.state;
        this.setState({
            limitNumberOfDevices: !limitNumberOfDevices,
            maxNumberOfDevices: maxNumberOfDevices === -1 && !limitNumberOfDevices ? DEFAULT_MAX_NUMBER_OF_DEVICES : maxNumberOfDevices
        }, () => {
            this.updateCohort();
        });
    }

    changeSelectPercentageFlag = () => {
        const { enabledSelectPercentage, selectPercentage } = this.state;
        const newEnabledSelectPercentage = !enabledSelectPercentage;
        this.setState({
            enabledSelectPercentage: newEnabledSelectPercentage,
            selectPercentage: newEnabledSelectPercentage && selectPercentage === -1 ? DEFAULT_SELECT_PERCENTAGE : selectPercentage
        }, () => {
            this.updateCohort();
        });
    }

    hasChanges() {
        const { cohort } = this.props;
        const { name, locations, maxNumberOfDevices, enabledSelectPercentage, selectPercentage } = this.state;

        return cohort.name !== name ||
            cohort.enabledSelectPercentage !== enabledSelectPercentage ||
            cohort.maxNumberOfDevices !== maxNumberOfDevices ||
            cohort.selectPercentage !== selectPercentage ||
            JSON.stringify(cohort.rules.locations) !== JSON.stringify(locations);
    }

    render() {
        const {
            name,
            nameFieldInfo,
            nameFieldError,
            maxNumberOfDevices,
            maxNumberOfDevicesFieldInfo,
            maxNumberOfDevicesFieldError,
            enabledSelectPercentage,
            selectPercentage,
            selectPercentageFieldError,
            limitedLocations,
            limitNumberOfDevices,
            currentNumberOfDevices,
            locations,
            saving
        } = this.state;

        const filled = cohortHelper.isFilled(limitNumberOfDevices, currentNumberOfDevices, maxNumberOfDevices);

        return <div className="cohort-form">
            <div className="cohort-form__body">
                <div className="cohort-form__row cohort-form__name-row">
                    <div className="cohort-form__label">
                        Cohort name
                    </div>
                    <TextFieldWrapper
                        placeholder="Name"
                        label="Name"
                        name="name"
                        id="name"
                        required={true}
                        value={name}
                        error={nameFieldError}
                        info={nameFieldInfo}
                        onLengthValidate={this.onLengthValidate}
                        onChange={this.onTextInputChange}
                        onBlur={this.onTextInputBlur} />
                </div>

                <div className="cohort-form__limit-users-row">
                    <div className="cohort-form__row cohort-form__current-users-row">
                        <div className={`cohort-form__label ${filled && 'filled'} top-level`}>
                            Current users
                        </div>
                        <div className="cohort-form__current-users-row__content">
                            <span className={`current ${filled && 'filled'}`}>{currentNumberOfDevices}</span> {limitNumberOfDevices && <React.Fragment>/ {maxNumberOfDevices}</React.Fragment>}
                        </div>
                    </div>
                </div>

                <div className="cohort-form__limit-users-row">
                    <FilterSwitcher
                        offMode={true}
                        minWidth="100%"
                        maxWidth="100%"
                        labelOnLeftSide={true}
                        onClick={this.changeNumberOfDevicesFlag}
                        value={limitNumberOfDevices} >
                        <div>
                            Limit the number of users <i
                                className="icon icon-alan-help-sign"
                                data-tip="Only users first to launch the app will be able to interact with Alan"
                                data-for="limitNumberOfDevices"
                                data-place="top"
                                data-effect="solid"
                                data-class="tutor-dark-tooltip" />
                            <ReactTooltip id="limitNumberOfDevices" />
                        </div>
                    </FilterSwitcher>
                </div>

                <div className={`cohort-form__section users-section ${limitNumberOfDevices && 'expanded'}`}>
                    <div className="cohort-form__row cohort-form__max-users-row">
                        <div className="cohort-form__label">
                            Max users
                        </div>
                        <TextFieldWrapper
                            placeholder="Users"
                            label="Users"
                            name="maxNumberOfDevices"
                            id="maxNumberOfDevices"
                            value={maxNumberOfDevices}
                            error={maxNumberOfDevicesFieldError}
                            info={maxNumberOfDevicesFieldInfo}
                            onChange={this.onTextInputChange}
                            onBlur={this.onTextInputBlur} />
                    </div>
                </div>

                <div className="cohort-form__select-percentage-row">
                    <FilterSwitcher
                        offMode={true}
                        minWidth="100%"
                        maxWidth="100%"
                        labelOnLeftSide={true}
                        onClick={this.changeSelectPercentageFlag}
                        value={enabledSelectPercentage} >
                        <div>
                            Percentage of users to apply cohort<i
                                className="icon icon-alan-help-sign"
                                data-tip="Users added to the cohort vs. max number of users"
                                data-for="PercentageOfUsersToApplyCohort"
                                data-place="top"
                                data-effect="solid"
                                data-class="tutor-dark-tooltip" />
                            <ReactTooltip id="PercentageOfUsersToApplyCohort" />
                        </div>
                    </FilterSwitcher>
                </div>
                <div className={`cohort-form__section select-percentage-section ${enabledSelectPercentage && 'expanded'}`}>
                    <div className="cohort-form__row cohort-form__max-users-row">
                        <div className="cohort-form__label">
                            Percentage of users
                        </div>
                        <TextFieldWrapper
                            placeholder="%"
                            label="%"
                            name="selectPercentage"
                            id="selectPercentage"
                            value={selectPercentage}
                            error={selectPercentageFieldError}
                            // info={selectPercentageFieldInfo}
                            onChange={this.onTextInputChange}
                            onBlur={this.onTextInputBlur} />
                    </div>
                </div>


                <div className="cohort-form__specify-locations-row">
                    <FilterSwitcher
                        labelIfTrue="Specify location"
                        labelIfFalse="Specify location"
                        offMode={true}
                        minWidth="100%"
                        maxWidth="100%"
                        labelOnLeftSide={true}
                        onClick={this.changeSpecifyLocationFlag}
                        value={limitedLocations} />
                </div>
                <div className={`cohort-form__section ${limitedLocations && 'expanded'}`}>
                    <div className="cohort-form__search-by-location-row">
                        <SearchLocation addLocation={this.addLocation} />
                    </div>
                    {locations.map((location, ind) => {
                        return <div
                            key={`${ind}-${location.name}`}
                            className="cohort-form__location-item">
                            <div className="cohort-form__location-item__name">
                                {location.name}
                            </div>
                            <i className="icon icon-alan-trash" onClick={() => { this.deleteLocation(ind); }} />
                        </div>;
                    })}
                </div>
            </div>
        </div>;
    }
}

function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createCohort: (param) => asyncDispatch(actions.createCohort, dispatch, param),
        updateCohort: (param) => asyncDispatch(actions.updateCohort, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CohortForm);
